/**
 * Constant value for the "start" request parameter.
 */
export const RequestParamStart = 'start';

/**
 * Constant value for the "limit" request parameter.
 */
export const RequestParamLimit = 'limit';

/**
 * Constant value for the "sortBy" request parameter.
 */
export const RequestParamSortBy = 'sortBy';

/**
 * Constant value for the generic "filter" request parameter.
 */
export const RequestParamFilter = 'filter';
//# sourceMappingURL=paging.js.map